import { render, staticRenderFns } from "./tabTree.vue?vue&type=template&id=7c15ca67&scoped=true&"
import script from "./tabTree.vue?vue&type=script&lang=js&"
export * from "./tabTree.vue?vue&type=script&lang=js&"
import style0 from "./tabTree.vue?vue&type=style&index=0&id=7c15ca67&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c15ca67",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VProgressCircular,VTab,VTabs})
